import axios from "axios"
import {ApiException, PermissionDenied, RecordNotFound, ValidationError} from "./exceptions";

class Client {
    constructor(jwt) {
        this.axios = axios.create({
            baseURL: import.meta.env.VITE_PICA_CORE_API_BASE_URL,
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
        if (jwt) this.axios.defaults.headers.common['Authorization'] = `Token ${jwt}`
    }

    get(url, params) {
        return this.axios.get(url, {params: params}).catch(error => this.throw_exception(error))
    }

    post(url, params) {
        return this.axios.post(url, params).catch(error => this.throw_exception(error))
    }

    patch(url, params) {
        return this.axios.patch(url, params).catch(error => this.throw_exception(error))
    }

    delete(url, params) {
        return this.axios.delete(url, params).catch(error => this.throw_exception(error))
    }

    put(url, params) {
        return this.axios.put(url, params).catch(error => this.throw_exception(error))
    }

    upload(url, form, onProgress) {
        return this.axios.post(url, form, {
            headers: {'Content-Type': 'multipart/form-data'},
            onUploadProgress: (progressEvent) => {
                onProgress({
                    loaded: progressEvent.loaded,
                    total: progressEvent.total
                })
            }
        }).catch(error => this.throw_exception(error))
    }

    throw_exception(error) {
        if (error.response) {
            if (error.response.status === 404)
                throw new RecordNotFound(error.response.config.url, error.response.status, error.response.data)
            if (error.response.status === 403)
                throw new PermissionDenied(error.response.config.url, error.response.status, error.response.data)
            if (error.response.status === 400)
                throw new ValidationError(error.response.config.url, error.response.status, error.response.data)
        }
        throw new ApiException(error.response.config.url, error.response.status, error.response.data)
    }
}

export default Client